import { render } from "./ShippingMethodsList.vue?vue&type=template&id=54ae83ec&ts=true"
import script from "./ShippingMethodsList.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodsList.vue?vue&type=script&lang=ts"

import "./ShippingMethodsList.vue?vue&type=style&index=0&id=54ae83ec&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__